import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SelectAll.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  fetchAllDeviceData,
  selectDeviceType,
  userCheckInu,
  userCheckWal,
  selectDeviceAllInfoData,
} from "../../store/deviceData/deviceDataSlice";

export default function SelectAll() {
  const [search, setSearch] = useState<string>("");
  const navigate = useNavigate();
  const [searchType, setSearchType] = useState<"name" | "prd_id">("name");
  const deviceType = useAppSelector(selectDeviceType);
  const deviceAllInfoData = useAppSelector(selectDeviceAllInfoData)
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchAllDeviceData({ deviceType, search, searchType }));
  }, [deviceType, search, searchType]);

  return (
    <>
      <select
        value={searchType}
        onChange={(e) => {
          console.log(e.target.value);
          console.log(search);
          setSearchType(e.target.value as "name" | "prd_id");
        }}
      >
        <option value="name">이름</option>
        <option value="prd_id">아이디</option>
      </select>

      <input
        type="text"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        placeholder="입력"
      />
      <button onClick={()=>dispatch(fetchAllDeviceData({ deviceType, search, searchType }))}>새로고침</button>
      <input
        type="radio"
        id="inu"
        checked={deviceType === "inu"}
        onChange={() => dispatch(userCheckInu())}
      />
      <label htmlFor="inu">inu</label>
      <input
        type="radio"
        id="wal"
        checked={deviceType === "wal"}
        onChange={() => dispatch(userCheckWal())}
      />
      <label htmlFor="wal">wal</label>
      {/* {deviceAllInfoData.map((item)=> (<div>{item.name}</div>))} */}
      {deviceAllInfoData && (
        <table>
          <thead>
            <tr>
              <th>prd_id</th>
              <th>name</th>
              <th>lng</th>
              <th>lat</th>
              <th>set_time</th>
            </tr>
          </thead>
          <tbody>
            {deviceAllInfoData.map((item, index) => (
              <tr
                key={index}
                onClick={() =>
                  navigate("/detail/" + deviceType + "/" + item.prd_id)
                }
              >
                <td>{item.prd_id}</td>
                <td>{item.name}</td>
                <td>{item.lng}</td>
                <td>{item.lat}</td>
                <td>{item.set_time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
